import APIConnector from "../lib/APIConnector";
import Settings from '../base/Settings'
const apiConnector = new APIConnector({ timeout: 30000 })

export default class RolConfig {
  static get endpoint(){
    return Settings.SERVICE_DOMAIN
  }
  static get endpointRoles() {
    return `${RolConfig.endpoint}/roles`;
  }
  // static get endpointSaveRol() {
  //   return `${RolConfig.endpointRoles}/save`;
  // }
  // static get endpointDeleteRol() {
  //   return `${RolConfig.endpointRoles}/delete`;
  // }
  static get APIConnector() {
    return apiConnector
  }
}



// WEBPACK FOOTER //
// ./src/provider/rol/RolConfig.js